import { Component } from '@angular/core';
import { Observable } from 'rxjs';

import { AuthService } from '../../../../core/services/auth/auth.service';
import { ApiToken } from '../../../../core/models/view-models/account-models/user-models/api-token.model';

@Component({
  selector: 'modal-add-user-api-token',
  templateUrl: './modal-add-user-api-token.component.html',
  styleUrls: ['./modal-add-user-api-token.component.scss']
})
export class ModalAddUserApiTokenComponent {
  saveIsInProgress: boolean;
  tokenName: string;
  createdToken: Observable<ApiToken>;
  userId: string

  constructor(private authService: AuthService) {}

  save(): void {
    this.saveIsInProgress = true;
    this.createdToken = this.authService.addUserApiToken(this.tokenName, this.userId);
  }
}
